import {
  AnchorRect,
  CLOSE_INSPECTOR,
  OPEN_CREATE,
  OPEN_INSPECTOR
} from "./documentSmartTextInspectorTypes";

export interface OpenInspectorAction {
  type: typeof OPEN_INSPECTOR;
  payload: { fieldId: string; anchorRect: AnchorRect | null };
}

export interface OpenCreateAction {
  type: typeof OPEN_CREATE;
  payload: { draftId: string; anchorRect: AnchorRect | null };
}

export interface CloseInspectorAction {
  type: typeof CLOSE_INSPECTOR;
}

export type DocumentSmartTextInspectorAction =
  | OpenInspectorAction
  | OpenCreateAction
  | CloseInspectorAction;

export const openInspector = (
  fieldId: string,
  anchorRect: AnchorRect | null
): OpenInspectorAction => ({
  type: OPEN_INSPECTOR,
  payload: { fieldId, anchorRect }
});

export const openCreate = (
  draftId: string,
  anchorRect: AnchorRect | null
): OpenCreateAction => ({
  type: OPEN_CREATE,
  payload: { draftId, anchorRect }
});

export const closeInspector = (): CloseInspectorAction => ({
  type: CLOSE_INSPECTOR
});
